
import $ from 'jquery';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import Toasted from 'vue-toasted';
import { initClient } from '../../../../api';
import { AccountApiClient, TreeNode, SurveyView } from '../../../backend/backendapi';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

Vue.use(Toasted, { duration: 2000 });

@Component({
  name: 'CopyModal',
  components: {
    vSelect,
  },
})
export default class CopyModal extends Vue {
  //data
  survey: SurveyView | null = null;
  name: string = '';
  shared: boolean = false;
  sharedWithAccounts: number[] = [];

  private readonly accountApi = initClient(AccountApiClient);
  accountsAvailableToShareWith: TreeNode[] = [];

  async mounted(): Promise<void> {
    await this.reload();
  }

  async reload(): Promise<void> {
    const accountSelect = await this.accountApi.getAccountSelect(undefined);
    if (typeof accountSelect.parentList !== 'undefined') this.accountsAvailableToShareWith = accountSelect.parentList;
  }

  openModal(survey: SurveyView): void {
    this.name = '';
    this.survey = survey;
    this.shared = false;
    this.sharedWithAccounts = [];
    $(this.$refs.modal!).modal('show');
  }

  closeModal(): void {
    $(this.$refs.modal!).modal('hide');
  }

  copySurvey(): void {
    this.$emit('copyTo', { survey: this.survey, name: this.name, shared: this.shared, sharedWithAccounts: this.sharedWithAccounts });
  }
}
